<template>
  <div v-show="loadingVisible"
       class="loading_cover">
    <div class="loading_img_container">
      <img src="../assets/imgs/loading_pay.gif"
           width="100%" />
      <div class="loading_error_msg">
        {{errorMsg}}{{successMsg}}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'aliPay',
  data: function () {
    return {
      orderId: '',
      loadingVisible: true,
      orderInfo: {},
      clientType: {},
      errorMsg: '',
      successMsg: '',
      userAgent: ''
    }
  },
  methods: {
    getOrderInfo () {
      if (this.userAgent.toLowerCase().indexOf('alipayclient') === -1) {
        this.errorMsg = '请使用支付宝扫码打开'
        return
      }

      let _this = this
      this.axios.get('/webApi/v3/order/aliSignData?id=' + _this.orderId).then(resp => {
        _this.loadingVisible = false
        AlipayJSBridge.call('tradePay', {
          orderStr: resp.data
        }, function (result) {
          AlipayJSBridge.call('popWindow')
          if (result.resultCode === '9000') {
            _this.errorMsg = ''
            _this.successMsg = '支付宝支付成功'
          } else {
            _this.successMsg = ''
            _this.errorMsg = '支付未失败'
          }
        })
      })
    }
  },
  components: {

  },
  mounted () {
    this.userAgent = window.navigator.userAgent
    this.orderId = this.$route.query.id
    this.getOrderInfo()
  },
  watch: {

  }
}
</script>

<style lang="less" scoped>
.loading_cover {
  width: 100%;
  height: 100%;
  background: white;
  position: fixed;
  top: 0;
  z-index: 9;
  left: 0;
}
.loading_img_container {
  width: 80%;
  left: 10%;
  position: relative;
  top: 30%;
}
.loading_error_msg {
  color: red;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/app/aliPay.vue